import * as React from "react";
function SvgGlasses(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 13h-1.126a4.002 4.002 0 01-7.845-.518 3.663 3.663 0 00-.209-.15C12.495 12.115 12.2 12 12 12c-.2 0-.495.115-.82.332-.077.05-.147.102-.209.15A4 4 0 013.126 13H2v-2h1.126a4.002 4.002 0 017.514-.66c.384-.185.853-.34 1.36-.34.508 0 .976.155 1.36.34a4 4 0 017.514.66H22v2zm-5 1a2 2 0 100-4 2 2 0 000 4zM7 14a2 2 0 100-4 2 2 0 000 4z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgGlasses);
export default ForwardRef;
